<script lang="ts">
      let { node, children = undefined } = $props()

      const { tag = 'p', format } = $state(node)
</script>

<svelte:element this={tag} class="lexical-paragraph {format}">
      {@render children?.()}
      {#if node.children.length == 0}
            <br />
      {/if}
</svelte:element>
